import { Component, input, output, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatOptionModule } from '@angular/material/core';
import { Product } from '../../models/product';
import { VirtualProductLabelComponent } from '../virtual-product-label/virtual-product-label.component';

@Component({
  selector: 'hire-item-search-result',
  standalone: true,
  imports: [CommonModule, MatOptionModule, VirtualProductLabelComponent],
  template: `
    <div class="flex items-center gap-x-2">
      <span>{{ product().name }}</span>
      @if (hasItems()) {
        <div class="flex items-center">
          <span>(</span>
          @for (
            item of items();
            track item.code;
            let last = $last;
            let first = $first
          ) {
            @if (!first) {
              <span>,&nbsp;</span>
            }
            <span
              [class.text-red-700]="item.onHire"
              [class.text-yellow-700]="item.hasWorkshopJobs"
              >{{ item.code }}</span
            >
          }
          <span>)</span>
        </div>
      } @else {
        @if (isVirtualProduct()) {
          <app-virtual-product-label />
        } @else {
          <span
            class="text-red-500 border border-red-500 rounded-md px-1 text-xs uppercase font-bold"
            >No Items</span
          >
        }
      }
    </div>
  `
})
export class SearchResultOptionComponent {
  product = input.required<Product>();

  // Computed properties
  hasItems = computed(() => {
    return this.product().items && this.product().items.length > 0;
  });

  items = computed(() =>
    this.product().items.map(({ code, status, has_current_workshop_jobs }) => ({
      code,
      onHire: status === 'On hire',
      hasWorkshopJobs: has_current_workshop_jobs
    }))
  );

  isVirtualProduct = computed(() => this.product().virtual);
}
